import { HighlightAccordion as HighlightAccordion$1 } from '@cbhq/cdx-components';
import { mapEntryLink } from '../globals/navlink.js';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_ACCORDION_CONTENT_MODEL_ID = 'cdxHighlightAccordion';
function HighlightAccordion({
  title,
  subtitle,
  link,
  cells,
  anchor,
  style = 'default',
  hasSpacingTop
}) {
  const navLink = link && mapEntryLink(link);
  return /*#__PURE__*/jsx(HighlightAccordion$1, {
    title: title,
    subtitle: subtitle,
    ctaLabel: navLink?.label,
    ctaUrl: navLink?.url,
    cells: cells?.map(cell => cell.fields),
    anchor: anchor,
    style: style,
    hasSpacingTop: hasSpacingTop
  });
}
export { HIGHLIGHT_ACCORDION_CONTENT_MODEL_ID, HighlightAccordion };
//# sourceMappingURL=HighlightAccordion.js.map
